module.exports = "/assets/js/92cff65742112aec8f7b10c258e7f38e.svg";